// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3qFU3","requiredAsterisk":"Info_requiredAsterisk__2_vh1"};